import { Beech } from './beech';
import { Emitter } from './emitter';
import { WorkerAction } from './worker-action';

export default class Foreman extends Emitter {
	private beech: Beech;
	private registration: any | null = null;
	private enabled: boolean = true;

	public constructor(beech: Beech) {
		super();
		logg.log('foreman >> init');
		this.beech = beech;
	}

	public register = () => {
		// Service worker is not needed in embedded mode
		if (this.beech.embedded.isEnabled()) {
			logg.log('foreman >> register >> not needed (embedded mode)');
			this.enabled = false;
			return;
		}

		logg.log('foreman >> register >> registering');

		(<any>navigator).serviceWorker.addEventListener('message', this.handleMessage);

		(<any>navigator).serviceWorker.addEventListener('controllerchange', this.handleControllerChange);

		(<any>navigator).serviceWorker
			.register('/worker.js?v=' + this.beech.config.release, { scope: '/' })
			.then((registration: any) => {
				this.registration = registration;
				logg.log('foreman >> registered', registration);
				this.send('load', {});
			})
			.catch((err: any) => {
				logg.error('foreman >> error', err);
			});

		$(window).on('beforeunload', () => {
			logg.log('foreman >> unload');
			this.send('unload', {});
		});
	};

	public send = (action: WorkerAction, extras: any) => {
		if (!this.enabled) {
			logg.debug(`foreman >> send(${action}) >> not enabled`);
			return;
		}

		if (!this.registration) {
			throw Error('Foreman >> Not Registered');
		}

		logg.log(`foreman >> send(${action})`, extras);

		this.registration.active.postMessage({ action: action, extras: extras });
	};

	private handleMessage = (event: any) => {
		if (!event.data.action) {
			logg.log('foreman >> message', event);
			return;
		}

		if (event.data.action == 'logg') {
			logg.info.apply(logg, [event.data.extras.message].concat(event.data.extras.data));
			return;
		}

		logg.log(`foreman >> message emit(${event.data.action})`, event.data.extras, event);

		this.emit(event.data.action, event.data.extras);
	};

	private handleControllerChange = (event: any) => {
		logg.log('foreman >> controller change', event);

		this.send('load', {});
	};
}
